import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { UiNotificationService } from 'src/app/external-ui-shared/services/ui-notification.service';
import { FormUtilsService } from 'src/app/shared/services/form-utils.service';
import { EmployeeCompany, EmployeeCompanyFormBuilder } from '../../models/EmployeeCompany';
import { EmployeeService } from '../../service/employee.service';

@Component({
  selector: 'app-employee-company-add',
  templateUrl: './employee-company-add.component.html',
  styleUrls: ['./employee-company-add.component.scss']
})
export class EmployeeCompanyAddComponent extends DialogContentBase 
implements OnInit {
  constructor(
    public dialog: DialogRef, 
    private fb: UntypedFormBuilder,
    private employeeService: EmployeeService, 
    private formUtilsService: FormUtilsService, 
    public uiNotification: UiNotificationService) {
    super(dialog);
  }

  @Input()entityId: number;
  addDataForm: UntypedFormGroup;
  addData: EmployeeCompany;

  ngOnInit(): void {

    this.addData = EmployeeCompanyFormBuilder.initEmployeeCompany();
    this.addData.entityId = this.entityId;
    this.addDataForm = EmployeeCompanyFormBuilder.getForm(this.fb, this.addData);
  }


  cancel() {
    this.dialog.close({ text: 'Cancel' });
  }

  confirm() {

    if (!this.formUtilsService.markFormGroupTouched(this.addDataForm)) {
      this.uiNotification.showValidationError();
      return;
    }

    Object.assign(this.addData, this.addDataForm.value);

    this.employeeService.storeEmployeeCompany(this.addData).subscribe(
      (resultId) => {
        this.uiNotification.showSuccess('validations.dataStoredSuccesfully');
        this.dialog.close({ text: 'OK', id: resultId});
      });
  }
}
